// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { InsurancePolicies_InsurancePolicyFragment } from '../../../InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import { gql } from '@apollo/client';
import { InsurancePolicies_InsurancePolicyFragmentDoc } from '../../../InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HypotheticalIlitModalData_EntityFragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTTrust', id: string } | { __typename?: 'CRTTrust', id: string } | { __typename?: 'CustodialPersonalAccount', id: string } | { __typename?: 'DonorAdvisedFund', id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATTrust', id: string } | { __typename?: 'ILITTrust', id: string } | { __typename?: 'IndividualPersonalAccount', id: string } | { __typename?: 'InsurancePersonalAccount', id: string } | { __typename?: 'IrrevocableTrust', id: string } | { __typename?: 'JointPersonalAccount', id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'PrivateFoundation', id: string } | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | { __typename?: 'RevocableTrust', id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } };

export type HypotheticalIlitModalData_InsurancePolicyFragment = (
  { __typename?: 'InsurancePolicy', id: string, householdID: string, cltTrust?: { __typename?: 'CLTTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null, crtTrust?: { __typename?: 'CRTTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null, daf?: { __typename?: 'DonorAdvisedFund', id: string, entity: { __typename?: 'Entity', id: string } } | null, ilitTrust?: { __typename?: 'ILITTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null, insurancePersonalAccount?: { __typename?: 'InsurancePersonalAccount', id: string, entity: { __typename?: 'Entity', id: string } } | null, irrevocableTrust?: { __typename?: 'IrrevocableTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null, privateFoundation?: { __typename?: 'PrivateFoundation', id: string, entity: { __typename?: 'Entity', id: string } } | null, revocableTrust?: { __typename?: 'RevocableTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null, slatTrust?: { __typename?: 'SLATTrust', id: string, entity: { __typename?: 'Entity', id: string } } | null }
  & InsurancePolicies_InsurancePolicyFragment
);

export type HypotheticalIlitModalData_HypotheticalInsuranceFragment = { __typename?: 'HypotheticalInsurance', id: string, displayName: string, startYear?: number | null, endYear?: number | null, endsOnKind: Types.HypotheticalInsuranceEndsOnKind, sourceEntityID?: string | null, sourceIndividualID?: string | null, sourceKind: Types.HypotheticalInsuranceSourceKind, transferFrequency: Types.HypotheticalInsuranceTransferFrequency, transferTaxKind: Types.HypotheticalInsuranceTransferTaxKind, transferValue: CurrencyUSD, existingInsurancePolicy?: (
    { __typename?: 'InsurancePolicy' }
    & HypotheticalIlitModalData_InsurancePolicyFragment
  ) | null, createdInsurancePolicy?: (
    { __typename?: 'InsurancePolicy' }
    & HypotheticalIlitModalData_InsurancePolicyFragment
  ) | null, giftingGrantors?: Array<{ __typename?: 'ClientProfile', id: string }> | null, destinationEntity?: { __typename?: 'Entity', id: string } | null };

export type HypotheticalIlitModalDataQueryVariables = Types.Exact<{
  hilitID: Types.Scalars['ID']['input'];
  hasHilitID: Types.Scalars['Boolean']['input'];
  householdID: Types.Scalars['ID']['input'];
}>;


export type HypotheticalIlitModalDataQuery = { __typename?: 'Query', entities?: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & HypotheticalIlitModalData_EntityFragment
      ) | null } | null> | null }, insurancePolicies: { __typename?: 'InsurancePolicyConnection', edges?: Array<{ __typename?: 'InsurancePolicyEdge', node?: (
        { __typename?: 'InsurancePolicy' }
        & HypotheticalIlitModalData_InsurancePolicyFragment
      ) | null } | null> | null }, estateWaterfalls?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string, hypotheticalInsurance?: { __typename?: 'HypotheticalInsuranceConnection', edges?: Array<{ __typename?: 'HypotheticalInsuranceEdge', node?: (
              { __typename?: 'HypotheticalInsurance' }
              & HypotheticalIlitModalData_HypotheticalInsuranceFragment
            ) | null } | null> | null } } | null } | null> | null } };

export type CreateHypotheticalInsuranceMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateHypotheticalInsuranceInput;
}>;


export type CreateHypotheticalInsuranceMutation = { __typename?: 'Mutation', createHypotheticalInsurance: (
    { __typename?: 'HypotheticalInsurance' }
    & HypotheticalIlitModalData_HypotheticalInsuranceFragment
  ) };

export type UpdateHypotheticalInsuranceMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateHypotheticalInsuranceInput;
}>;


export type UpdateHypotheticalInsuranceMutation = { __typename?: 'Mutation', updateHypotheticalInsurance: (
    { __typename?: 'HypotheticalInsurance' }
    & HypotheticalIlitModalData_HypotheticalInsuranceFragment
  ) };

export type DeleteHypotheticalInsuranceMutationVariables = Types.Exact<{
  hilitIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DeleteHypotheticalInsuranceMutation = { __typename?: 'Mutation', deleteHypotheticalInsurances: number };

export const Operations = {
  Query: {
    HypotheticalILITModalData: 'HypotheticalILITModalData' as const
  },
  Mutation: {
    CreateHypotheticalInsurance: 'CreateHypotheticalInsurance' as const,
    UpdateHypotheticalInsurance: 'UpdateHypotheticalInsurance' as const,
    DeleteHypotheticalInsurance: 'DeleteHypotheticalInsurance' as const
  },
  Fragment: {
    HypotheticalILITModalData_Entity: 'HypotheticalILITModalData_Entity' as const,
    HypotheticalILITModalData_InsurancePolicy: 'HypotheticalILITModalData_InsurancePolicy' as const,
    HypotheticalILITModalData_HypotheticalInsurance: 'HypotheticalILITModalData_HypotheticalInsurance' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HypotheticalIlitModalData_EntityFragmentDoc = gql`
    fragment HypotheticalILITModalData_Entity on Entity {
  id
  subtype {
    id
  }
}
    `;
export const HypotheticalIlitModalData_InsurancePolicyFragmentDoc = gql`
    fragment HypotheticalILITModalData_InsurancePolicy on InsurancePolicy {
  id
  householdID
  cltTrust {
    id
    entity {
      id
    }
  }
  crtTrust {
    id
    entity {
      id
    }
  }
  daf {
    id
    entity {
      id
    }
  }
  ilitTrust {
    id
    entity {
      id
    }
  }
  insurancePersonalAccount {
    id
    entity {
      id
    }
  }
  irrevocableTrust {
    id
    entity {
      id
    }
  }
  privateFoundation {
    id
    entity {
      id
    }
  }
  revocableTrust {
    id
    entity {
      id
    }
  }
  slatTrust {
    id
    entity {
      id
    }
  }
  ...InsurancePolicies_InsurancePolicy
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const HypotheticalIlitModalData_HypotheticalInsuranceFragmentDoc = gql`
    fragment HypotheticalILITModalData_HypotheticalInsurance on HypotheticalInsurance {
  id
  displayName
  existingInsurancePolicy {
    ...HypotheticalILITModalData_InsurancePolicy
  }
  createdInsurancePolicy {
    ...HypotheticalILITModalData_InsurancePolicy
  }
  giftingGrantors {
    id
  }
  startYear
  endYear
  endsOnKind
  sourceEntityID
  sourceIndividualID
  sourceKind
  transferFrequency
  transferTaxKind
  transferValue
  destinationEntity {
    id
  }
}
    ${HypotheticalIlitModalData_InsurancePolicyFragmentDoc}`;
export const HypotheticalIlitModalDataDocument = gql`
    query HypotheticalILITModalData($hilitID: ID!, $hasHilitID: Boolean!, $householdID: ID!) {
  entities(where: {id: $hilitID}) @include(if: $hasHilitID) {
    edges {
      node {
        ...HypotheticalILITModalData_Entity
      }
    }
  }
  insurancePolicies(
    where: {hasHouseholdWith: [{id: $householdID}], hasHypotheticalInsurance: false}
  ) {
    edges {
      node {
        ...HypotheticalILITModalData_InsurancePolicy
      }
    }
  }
  estateWaterfalls(where: {hasHypotheticalInsuranceWith: [{id: $hilitID}]}) @include(if: $hasHilitID) {
    edges {
      node {
        id
        hypotheticalInsurance(where: {id: $hilitID}) @include(if: $hasHilitID) {
          edges {
            node {
              ...HypotheticalILITModalData_HypotheticalInsurance
            }
          }
        }
      }
    }
  }
}
    ${HypotheticalIlitModalData_EntityFragmentDoc}
${HypotheticalIlitModalData_InsurancePolicyFragmentDoc}
${HypotheticalIlitModalData_HypotheticalInsuranceFragmentDoc}`;

/**
 * __useHypotheticalIlitModalDataQuery__
 *
 * To run a query within a React component, call `useHypotheticalIlitModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHypotheticalIlitModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHypotheticalIlitModalDataQuery({
 *   variables: {
 *      hilitID: // value for 'hilitID'
 *      hasHilitID: // value for 'hasHilitID'
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useHypotheticalIlitModalDataQuery(baseOptions: Apollo.QueryHookOptions<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>(HypotheticalIlitModalDataDocument, withFetchPolicyContext(options));
      }
export function useHypotheticalIlitModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>(HypotheticalIlitModalDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHypotheticalIlitModalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>(HypotheticalIlitModalDataDocument, withFetchPolicyContext(options));
        }
export type HypotheticalIlitModalDataQueryHookResult = ReturnType<typeof useHypotheticalIlitModalDataQuery>;
export type HypotheticalIlitModalDataLazyQueryHookResult = ReturnType<typeof useHypotheticalIlitModalDataLazyQuery>;
export type HypotheticalIlitModalDataSuspenseQueryHookResult = ReturnType<typeof useHypotheticalIlitModalDataSuspenseQuery>;
export type HypotheticalIlitModalDataQueryResult = Apollo.QueryResult<HypotheticalIlitModalDataQuery, HypotheticalIlitModalDataQueryVariables>;
export const CreateHypotheticalInsuranceDocument = gql`
    mutation CreateHypotheticalInsurance($input: AugmentedCreateHypotheticalInsuranceInput!) {
  createHypotheticalInsurance(input: $input) {
    ...HypotheticalILITModalData_HypotheticalInsurance
  }
}
    ${HypotheticalIlitModalData_HypotheticalInsuranceFragmentDoc}`;
export type CreateHypotheticalInsuranceMutationFn = Apollo.MutationFunction<CreateHypotheticalInsuranceMutation, CreateHypotheticalInsuranceMutationVariables>;

/**
 * __useCreateHypotheticalInsuranceMutation__
 *
 * To run a mutation, you first call `useCreateHypotheticalInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHypotheticalInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHypotheticalInsuranceMutation, { data, loading, error }] = useCreateHypotheticalInsuranceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHypotheticalInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<CreateHypotheticalInsuranceMutation, CreateHypotheticalInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHypotheticalInsuranceMutation, CreateHypotheticalInsuranceMutationVariables>(CreateHypotheticalInsuranceDocument, options);
      }
export type CreateHypotheticalInsuranceMutationHookResult = ReturnType<typeof useCreateHypotheticalInsuranceMutation>;
export type CreateHypotheticalInsuranceMutationResult = Apollo.MutationResult<CreateHypotheticalInsuranceMutation>;
export type CreateHypotheticalInsuranceMutationOptions = Apollo.BaseMutationOptions<CreateHypotheticalInsuranceMutation, CreateHypotheticalInsuranceMutationVariables>;
export const UpdateHypotheticalInsuranceDocument = gql`
    mutation UpdateHypotheticalInsurance($input: AugmentedUpdateHypotheticalInsuranceInput!) {
  updateHypotheticalInsurance(input: $input) {
    ...HypotheticalILITModalData_HypotheticalInsurance
  }
}
    ${HypotheticalIlitModalData_HypotheticalInsuranceFragmentDoc}`;
export type UpdateHypotheticalInsuranceMutationFn = Apollo.MutationFunction<UpdateHypotheticalInsuranceMutation, UpdateHypotheticalInsuranceMutationVariables>;

/**
 * __useUpdateHypotheticalInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdateHypotheticalInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHypotheticalInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHypotheticalInsuranceMutation, { data, loading, error }] = useUpdateHypotheticalInsuranceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHypotheticalInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHypotheticalInsuranceMutation, UpdateHypotheticalInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHypotheticalInsuranceMutation, UpdateHypotheticalInsuranceMutationVariables>(UpdateHypotheticalInsuranceDocument, options);
      }
export type UpdateHypotheticalInsuranceMutationHookResult = ReturnType<typeof useUpdateHypotheticalInsuranceMutation>;
export type UpdateHypotheticalInsuranceMutationResult = Apollo.MutationResult<UpdateHypotheticalInsuranceMutation>;
export type UpdateHypotheticalInsuranceMutationOptions = Apollo.BaseMutationOptions<UpdateHypotheticalInsuranceMutation, UpdateHypotheticalInsuranceMutationVariables>;
export const DeleteHypotheticalInsuranceDocument = gql`
    mutation DeleteHypotheticalInsurance($hilitIds: [ID!]!) {
  deleteHypotheticalInsurances(ids: $hilitIds)
}
    `;
export type DeleteHypotheticalInsuranceMutationFn = Apollo.MutationFunction<DeleteHypotheticalInsuranceMutation, DeleteHypotheticalInsuranceMutationVariables>;

/**
 * __useDeleteHypotheticalInsuranceMutation__
 *
 * To run a mutation, you first call `useDeleteHypotheticalInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHypotheticalInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHypotheticalInsuranceMutation, { data, loading, error }] = useDeleteHypotheticalInsuranceMutation({
 *   variables: {
 *      hilitIds: // value for 'hilitIds'
 *   },
 * });
 */
export function useDeleteHypotheticalInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHypotheticalInsuranceMutation, DeleteHypotheticalInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHypotheticalInsuranceMutation, DeleteHypotheticalInsuranceMutationVariables>(DeleteHypotheticalInsuranceDocument, options);
      }
export type DeleteHypotheticalInsuranceMutationHookResult = ReturnType<typeof useDeleteHypotheticalInsuranceMutation>;
export type DeleteHypotheticalInsuranceMutationResult = Apollo.MutationResult<DeleteHypotheticalInsuranceMutation>;
export type DeleteHypotheticalInsuranceMutationOptions = Apollo.BaseMutationOptions<DeleteHypotheticalInsuranceMutation, DeleteHypotheticalInsuranceMutationVariables>;